import React from "react";
import { getPhoneStatusPresentation } from "./phoneStatusLabels";

const PhoneStatusBar = ({ state, error, t, onDisconnect, showDisconnect = false }) => {
  const { label, className } = getPhoneStatusPresentation(state, t);

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between gap-2">
        <span
          className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold ${className}`}
        >
          {label}
        </span>
        {showDisconnect ? (
          <button
            type="button"
            className="text-xs font-medium text-slate-500 underline-offset-2 hover:text-slate-800 hover:underline"
            onClick={onDisconnect}
          >
            {t("ccDisconnectPhone")}
          </button>
        ) : null}
      </div>
      {error ? (
        <p className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs leading-relaxed text-amber-900">
          {error}
        </p>
      ) : null}
    </div>
  );
};

export default PhoneStatusBar;
